/**
 * This function get data from the local storage and if this doesn't exist,
 * it is stored in the localstorage
 * @param {String} value this is the name of the parameter to searches in the localstorage
 * @param {String} defaultValue is the default value if the local storage is empty
 * @returns the value from the local storage
 */
export default function loadFromLocalstorage(value, defaultValue) {
  const storage = JSON.parse(localStorage.leo || '{}');
  const valueFromStorage = storage[value];

  // If the value doesn't exis, the deafult value is store in the localsotrage
  if (!valueFromStorage) {
    storage[value] = defaultValue;
    localStorage.leo = JSON.stringify({ ...storage });
  }

  /**
   * Return the value fron the localstorage and if it doesn't
   * exist return the default value
   * */
  return valueFromStorage || defaultValue;
}
